function toggleStickybarClass() {
  const el = document.getElementById("bundle-items");
  const stickybarInner = document.querySelector(".stickybar__inner");

  if (!el || !stickybarInner) return;

  const hasScrollbar = el.scrollWidth > el.clientWidth;

  if (window.innerWidth > 1024) {
    if (hasScrollbar) {
      stickybarInner.classList.add("has-scrollbar");
    } else {
      stickybarInner.classList.remove("has-scrollbar");
    }
  } else {
    stickybarInner.classList.remove("has-scrollbar");
  }
}

window.addEventListener("load", toggleStickybarClass);
window.addEventListener("resize", toggleStickybarClass);

const observer = new MutationObserver(toggleStickybarClass);
//observer.observe(document.getElementById("bundle-items"), { childList: true, subtree: true });
const el = document.getElementById("bundle-items");
if (el) {
  observer.observe(el, { childList: true, subtree: true });
}

